import request from '../utils/request';
import { getLanguageUrl } from "@/utils/index";

/**
 * 课程列表
 */
export function learningtourNew(params) {

    let url = ''

    if (process.env.ENV_CONFIG == 'devOverseas' || process.env.ENV_CONFIG == 'prodOverseas' || process.env.ENV_CONFIG == 'thdev' || process.env.ENV_CONFIG == 'thuat' || process.env.ENV_CONFIG == 'thprod') {
        url = '/sr/learningtour'
    } else {
        url = '/sr/v2/learningtournew'
    }
    url = getLanguageUrl(url)
    return request.MainService({
        url: url,
        method: 'get',
        data: params
    })
}
/**
 * 获取用户课程进度
 */
export function learningProgress(params) {
    return request.MainService({
        url: '/ddilearner/v2/user/learning/progress',
        method: 'get',
        data: params
    })
}
/**
 * 获取是否展示学习弹窗
 * @param {*} id
 * learningPathMetaId 课程配置ID 需加上0009
 */
export function getOnceino(id) {
    return request.MainService({
        url: `/sr/onceino/${id}`,
        method: 'get',
        data: {}
    })
}
/**
 * 保存点击学习收获弹窗
 * @param {*} id
 * learningPathMetaId 课程配置ID 需加上0009
 */
export function postOnceino(id) {
    return request.MainService({
        url: `/sr/onceino/${id}`,
        method: 'post',
        data: {}
    })
}
/**
 * 获取单门课程进度
 * @param {*} id
 * learningPathMetaIds 课程配置ID
 * projectId 项目下的课程需要传projectId
 */
export function learnProgress(id,projectId) {
    let url = `/ddilearner/v2/user/learning/progress?learningPathMetaIds=${id}`
    if(projectId || projectId == 0){
      url += `&projectId=${projectId}`
    }
    return request.MainService({
        url,
        method: 'get',
        data: {}
    })
}
//获取当前课程测学练考内容
export function learningpathesUser(params, data) {
    return request.MainService({
        url: `/ddilearner/v2/user/learningpathes/${data.id}`,
        method: 'get',
        params: params
    })
}
//获取当前课程测学练考内容
export function learningpathes(params, data) {
    return request.MainService({
        url: `/ddilearner/v2/learningpathes/${data.id}`,
        method: 'get',
        params: params
    })
    // response data
    // type为模块类型 1-课前诊断 2-课程学习 3-情景模拟 4-课后考核 null-已完成
    // 当type=1 或 type=4 id为null
    // 当type=2 当前id为微课练习id
    // 当type=3 当前id为情景模拟练习id
}

/**
 * 获取项目课程下的附属作业
 * @param projectId  项目id
 * @param learningPathMetaId  课程id
 * @returns {AxiosPromise}
 */
export function getHomeWorkByCourse(projectId,learningPathMetaId){
  return request.MainService({
    url:`/ddilearner/v2/user/learning/homeworkList?projectId=${projectId}&learningPathMetaId=${learningPathMetaId}`,
    method: 'get'
  })
}

/**
 * 获取项目课程下的作业数据
 * @param homeworkDuplicateId  作业id
 * @returns {AxiosPromise}
 */
export function getHomeWorkInfoByCourse(homeworkDuplicateId){
  return request.MainService({
    url:`/ddilearner/v2/user/project/homework?homeworkDuplicateId=${homeworkDuplicateId}`,
    method: 'get'
  })
}

/**
 * 保存用户填写反馈问卷信息
 */
export function saveUsersSatisficing(params) {
    return request.MainService({
        url: '/ddilearner/v1/usersSatisficing',
        method: 'post',
        data: params
    });
}

/**
 * 获取用户填写反馈问卷信息
 * @param id
 * @returns
 */
export function getUsersSatisficingMetasInfo(id) {
    return request.MainService({
        url: `/ddilearner/v1/usersSatisficing/learningPathMetaId/${id}`,
        method: 'get',
        data: {}
    })
}

/**
 * 获取SCORM课程列表
 *
 * 本函数通过调用主服务的GET方法来获取SCORM课程列表它使用了request.MainService，这是一个封装了axios或其他HTTP库的自定义服务，
 * 以便于在整个应用程序中统一处理请求和响应这个函数没有输入参数，但返回一个Promise对象，该对象解析为课程列表数据
 *
 * @returns {Promise} 一个Promise对象，解析为SCORM课程列表的数据
 */
export function getSCORMList() {
  return request.MainService({
    url: '/ddilearner/v1/learningPathScorm/courseList',
    method: 'get'
  })
}


/**
 * 获取反馈问卷信息（当用户完成情景模拟以及未填写反馈问卷）
 * @returns
 */
export function getUsersSatisficingMetas() {
    return request.MainService({
        url: `/ddilearner/v1/usersSatisficingMetas`,
        method: 'get',
        data: {}
    })
}

/**
 * 每一次测验记录时长初始化
 * 说明：当DNA测验每一次打开需要计时器的情况下调用本次接口
 * @type 0 DNA 2前测 3后测
 */
export function tickInit(params) {
    return request.MainService({
        url: `/ddilearner/v1/user/tick/init/${params.type}`,
        method: 'post',
        data: params
    });
}

/**
 * 发送计时接口（每隔1秒调用一次）
 * 说明：用于记录每个测验所花费的时长
 */
export function tickUpdate(params) {
    return request.MainService({
        url: `/ddilearner/v1/user/tick/update/${params.tickId}`,
        method: 'post',
        data: params
    });
}

/**
 * 每一次测验记录时长重置
 */
export function tickReset(params) {
    return request.MainService({
        url: `ddilearner/v1/user/tick/reset/${params.type}`,
        method: 'post',
        data: params
    });
}

/**
 * 获取智能作业
 */
export function getPracticeList(learningPathMetaId) {
    return request.MainService({
        method: 'GET',
        url: `/ddilearner/v2/camp/applicationPractice/constitute/${learningPathMetaId}`,
        data: {}
    })
}

/**
 * 获取智能作业详情
 */
export function getQuestionGroup(constituteId) {
    return request.MainService({
        method: 'GET',
        url: `/ddilearner/v2/camp/applicationPractice/getQuestionGroup/${constituteId}`,
        data: {}
    })
}

//获取我的作答优秀点赞评价数据
export function getMyAnswerEvaluate(homeworkDuplicateId,exerciseType) {
    return request.MainService({
        method: 'GET',
        url: exerciseType? '/ddilearner/v2/camp/applicationPractice/getMyAnswer/' + homeworkDuplicateId : `/ddilearner/v2/user/project/homework/getMyAnswer/${homeworkDuplicateId}`,
        data: {}
    })
}

//获取学员作答数据
export function getStudentAnswers(homeworkDuplicateId,exerciseType) {
    return request.MainService({
        method: 'GET',
        url: exerciseType? '/ddilearner/v2/camp/applicationPractice/getStudentAnswerV2/' + homeworkDuplicateId : `/ddilearner/v2/user/project/homework/getStudentAnswer/${homeworkDuplicateId}`,
        data: {}
    })
}

//点赞
export function saveAppreciate(data,exerciseType) {
    return request.MainService({
        method: 'post',
        url:exerciseType? '/ddilearner/v2/camp/applicationPractice/saveOperationLog' : '/ddilearner/v2/user/project/homework/saveOperationLog',
        data: data
    })
}

//点赞列表
export function getAppreciate(exerciseType) {
    return request.MainService({
        method: 'get',
        url:exerciseType? '/ddilearner/v2/camp/applicationPractice/getOperationLogList/3' : '/ddilearner/v2/user/project/homework/getOperationLogList/3',
        data: {}
    })
}

// //追问 评论
// export function askQuestion(data,homeworkDuplicateId) {
//     return request.MainService({
//         method: 'post',
//         url: `/ddilearner/v2/user/project/homework/saveOperationLog${homeworkDuplicateId}`,
//         data: data
//     })
// }

/**
 * 保存训练营作业答案
 */
export function saveAnswersByCamp(data) {
  return request.MainService({
    method: 'post',
    url: `ddilearner/v2/camp/applicationPractice/saveAnswers`,
    data
  })
}

/**
 * 保存训练营作业答案
 */
export function campSaveAnswers(lastDay,data) {
  return request.MainService({
    method: 'post',
    url: !lastDay? 'ddilearner/v2/camp/applicationPractice/actualOperation/saveFirstDayTask' :`ddilearner/v2/camp/applicationPractice/saveAnswers`,
    data
  })
}


/**
 * 保存项目作业答案
 */
export function savePorjectWorkAnswers(data) {
  return request.MainService({
    method: 'post',
    url: `/ddilearner/v2/user/project/homework/saveAnswers`,
    data:{...data,terminalType:1} //1:pc 2:mobile
  })
}

/**
 * 根据第一题选择的选项id获取PDF文件
 * @param postData: JSONObject 选择题选项
 */
export function getExercisePdfAPI(data) {
  return request.MainService({
    method: 'POST',
    url: 'ddilearner/v2/camp/applicationPractice/actualOperation/getExercisePdf',
    data
  })
}

/**
 * 训练营获取上传文件列表
 * @param postData: JSONObject 查询文件条件对象
 */
export function getUploadFileList(data) {
  return request.MainService({
    method: 'POST',
    url: 'ddilearner/v2/camp/applicationPractice/actualOperation/getCampFileList',
    data,
  })
}

/**
 * 项目独立作业获取上传文件列表
 * @param postData: JSONObject 查询文件条件对象
 */
export function getProjectWorkUploadFileList(data) {
  return request.MainService({
    method: 'POST',
    url: 'ddilearner/v2/user/project/homework/getHomeworkFileList',
    data,
  })
}

/**
 * 训练营作业上传文件
 */
export function fileUploadApi(data) {
  return request.MainService({
    method: 'POST',
    url: 'ddilearner/v2/camp/applicationPractice/actualOperation/' + data.constituteId + '/' + data.questionId + '/fileUpload',
    data:data.files,
  })
}


/**
 * 项目作业上传附件
 */
export function projectFileUploadApi(data,homeworkDuplicateId) {
  return request.MainService({
    method: 'POST',
    url: `ddilearner/v2/user/project/homework/${homeworkDuplicateId}/fileUpload`,
    data:data.files,
  })
}

/**
 * 项目作业上传附件，需要带toolskey
 */
export function projectFileUploadApiNew(data,homeworkDuplicateId,toolsKey) {
  return request.MainService({
    method: 'POST',
    url: `ddilearner/v3/user/project/homework/${homeworkDuplicateId}/${toolsKey}/fileUpload`,
    data:data.files,
  })
}

/**
 * 项目作业下载附件
 */
export function projectFileDownloadApi(path,name) {
  return request.MainService({
    method: 'get',
    url: `ddilearner/v2/user/project/homework/downloadFile?path=${path}&fileName=${name}`,
    responseType:'arraybuffer'
  })
}

/**
 * 创建learningPathid
 */
 export function createLearningPathUrl(learningPathMetaId) {
  return request.MainService({
    method: 'POST',
    url: `ddilearner/v1/${learningPathMetaId}/learningpathes`,
  })
}

 // 根据learningPathMetaId创建或者获取LearningPath
 export function getOrCreateLearningPath(learningPathMetaId){
  return request.MainService({
    method: 'GET',
    url: 'ddilearner/v2/user/learningpathes/'+learningPathMetaId
  })
}

 // 智能陪练短链登录校验
 export function checkIntelligentStub(projectId,courseId){
  return request.MainService({
    method: 'GET',
    url: `ddilearner/v3/project/validateAirpLink?projectId=${projectId}&courseId=${courseId}`
  })
}



// WEBPACK FOOTER //
// ./src/api/course.js